import React from 'react'
import { Link as RrLink } from 'react-router-dom'

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  replace?: boolean
  scroll?: boolean
  prefetch?: boolean
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, replace, scroll, prefetch, children, ...props }, ref) => {
    return (
      <RrLink
        ref={ref}
        to={href}
        replace={replace}
        {...props}
      >
        {children}
      </RrLink>
    )
  }
)

Link.displayName = 'Link'

export default Link
